export const CONSTANTS = {
  CURRENCY_FORMAT: '1.2-2',
  DATE_FORMAT: 'dd-MMM-yyyy',
  DATE_TIME_FORMAT: 'yyyy-MM-dd HH:mm:ss',
  TIMEZONE_UTC: 'UTC',
  PDF_DATE_FORMAT: 'YYYY-MM-DD',
  pageSizeOptions: [25, 50, 100],
  CREATE_OPERATION: 'CREATE',
  CANCEL_OPERATION: 'CANCEL',
  CREDIT_STATUS_FULLY: 'FULLY_CREDITED',
  CREDIT_STATUS_PARTIAL: 'PARTIALLY_CREDITED',
  INVOICE_TYPE_CREDIT: 'CREDIT',
  BE_DATE_FORMAT: 'YYYY-MM-DD',
  TABLE_NO_DATA: 'No data found',
  ACM_PARTIAL: 'ACM_PARTIAL',
  APP_TITLE: 'Faturti',
  AUTHORIZATION: 'Authorization',
  VIEW_SMS_APPLICATION: 'VIEW_SMS_TABS',
  ADMIN_DESIGNATION: 'ADMIN',
  USER_GROUP: 'userGroups',
  STORE_IS_ROLE_ADMIN: 'isAdmin',
  STORE_USER_ID: 'userId',
  STORE_USER_NAME: 'userName',
  MIN_EXP_DAYS_FOR_API_KEY: 7,
  MAX_EXP_YEAR_FOR_API_KEY: 1,
  EXP_DATE_FORMAT: "yyyy-MM-dd'T'HH:mm:ss",
  DISPLAY_EXP_DATE_TIME: 'dd/MM/yyyy h:mm a',
  DISPLAY_DATE_TIME: 'DD/MM/YYYY h:mm A',
};
